export * from './account.service';
import { AccountService } from './account.service';
export * from './authentication.service';
import { AuthenticationService } from './authentication.service';
export * from './health.service';
import { HealthService } from './health.service';
export * from './paymentRequestTask.service';
import { PaymentRequestTaskService } from './paymentRequestTask.service';
export const APIS = [AccountService, AuthenticationService, HealthService, PaymentRequestTaskService];
